import { navigate, RouteComponentProps } from '@reach/router'
import { Formik } from 'formik'
import { TFunction } from 'i18next'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMembershipTerms } from 'src/App/auth/register/register'
import { MembershipCodeEnum } from 'src/graphql-types/globalTypes'
import { SC_PAYMENT_ROUTE } from 'src/utils/constants/routes'
import * as yup from 'yup'
import { setCurrentStep, setPlayerDetails } from '../../../utils/localStorage/local-storage'
import SummerCircuitDetailsForm from '../summer-circuit-details-form/summer-circuit-details-form'

interface PaymentProps extends RouteComponentProps<any> {
  setStep?: React.Dispatch<React.SetStateAction<number>>
  membership?: string
  isSummerCircuit?: boolean
}

const getValidationSchema = (t: TFunction) =>
  yup.object().shape({
    city: yup.string().required(t('is required', { type: 'city' })),
    state: yup.string().required(t('is required', { type: 'state' })),
    status: yup.string().required(t('is required', { type: 'school' })),
    yearInSchool: yup.string().required(t('is required', { type: 'year in school' })),
    collegiateDivision: yup.string().required(t('is required', { type: 'collegiate division' }))
  })

const SummerCircuitDetails: React.FC<PaymentProps> = () => {
  const { t } = useTranslation()
  const validationSchema = getValidationSchema(t)

  const { hasMultipleActiveTerms } = useMembershipTerms(MembershipCodeEnum.PLA)

  const initialValues = {
    city: '',
    state: '',
    status: '',
    yearInSchool: '',
    collegiateDivision: ''
  }

  const handleSubmit = values => {
    setPlayerDetails(values)
    navigate(SC_PAYMENT_ROUTE)
    // If multiple active terms, there's an additional first step to select the term
    setCurrentStep(hasMultipleActiveTerms ? '2' : '1')
  }

  return (
    <>
      <Formik
        validationSchema={validationSchema}
        initialValues={initialValues}
        onSubmit={handleSubmit}
      >
        {formikProps => <SummerCircuitDetailsForm {...formikProps} />}
      </Formik>
    </>
  )
}

export default SummerCircuitDetails
